import axios from "axios";
import { API_URL } from "../../../utils/constants";

export const getAzureFunctionalAppApi = async (param, provider) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem("api_token");
    const endpoint = provider === "gcp" ? "gcp/cloud-functions" : "fetch-function-apps-from-db";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};
